'use client';

import PageSection from 'components/containers/page-section';
import FilterSet from 'components/controls/filters/filterset';
import { useState } from 'react';
import Subsection from 'components/containers/sub-section';
import { ArchivalLabelsWithViewer } from 'components/collection/archival-label-viewer/objects-as-archival-label-with-viewer';
import { type IObjectAsLauderArchivalLabel } from '@metmuseum/types';

const ArchivalLabelsFilter = ({ filters, archivalLabels }: IProps) => {
	const [activeFilter, setActiveFilter] = useState('All');

	const handleFilterChange = (event) => {
		if (event.target.checked) {
			setActiveFilter(event.target.name);
		} else {
			setActiveFilter('All');
		}
	};

	const filteredArchivalLabels =
		activeFilter === 'All'
			? archivalLabels
			: archivalLabels.filter(
					(archivalLabel) => activeFilter === archivalLabel.purpose,
				);

	return (
		<>
			<Subsection>
				<FilterSet
					labelText="Filter by label type:"
					wrap={true}
					filtersFor="Archival Labels"
					filterOptions={filters}
					filterState={filters.reduce((filterState, filter) => {
						filterState[filter.value] = activeFilter === filter.value;
						return filterState;
					}, {})}
					handleInputChange={handleFilterChange}
					screenReaderLegend="Select optional categories to filter results"
					sideForChildren="right"
				/>
			</Subsection>
			<PageSection>
				<ArchivalLabelsWithViewer
					enforceMaxObjectWidth={true}
					archivalLabels={filteredArchivalLabels}
				/>
			</PageSection>
		</>
	);
};

export default ArchivalLabelsFilter;

interface IProps {
	filters: { name: string; value: string }[];
	archivalLabels: IObjectAsLauderArchivalLabel[];
}
